﻿var afmeldModule = angular.module("afmeldModule", ["ngRoute", "ntaComponents", "progressModule", "ngAnimate", "ngMaterial", "ntaLogger"])
    .config([ '$routeProvider', '$locationProvider', '$mdThemingProvider', function ($routeProvider, $locationProvider, $mdThemingProvider) {
        $locationProvider.html5Mode(true);

        $mdThemingProvider.theme('default')
            .primaryPalette('light-green')
            .accentPalette('orange');
    }]);

